import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  list: {
    padding: 0,
  },
  item: {
    padding: theme.spacing(2, 6),
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  text: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: theme.typography.h1.fontWeight,
  },
}));
